import {
  TCustomerAvailableFeatures,
  TRawCustomerAvailableFeatures,
} from 'models/commonApi.model'
import 'models/config.model'

export const getAvailableFeatures = (
  features?: TRawCustomerAvailableFeatures,
): TCustomerAvailableFeatures => ({
  extrasAvailable: features?.extras_available ?? false,
  pauseAvailable: features?.pause_available ?? false,
})
